export const ticketingSalesQueryKeys = {
  all: ["ticketing-sales"] as const,
  event: (eventId: string) =>
    [...ticketingSalesQueryKeys.all, eventId] as const,
};
